/**
 * assets/bottom-sheet.js
 * Gedrag van snippets/bottom-sheet.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15.
 *
 * WAAROM DIT GEEN 1:1 KNIP IS
 * De oude inline versie was per instantie gerenderd: elke {% render
 * 'bottom-sheet', id: '...' %} zette een eigen kopie van dezelfde 79 regels in
 * de HTML, met de id hardgecodeerd via {{ id }}. Dat is precies het patroon dat
 * ARCHITECTURE.md sectie 11 verbiedt. Deze versie bindt zich aan ALLE
 * [data-bottom-sheet]-elementen op de pagina; de id komt uit het DOM-attribuut.
 *
 * PUBLIEKE API, ONGEWIJZIGD
 * window['bottomSheet_' + <id | handleize>] = { open, close }
 * Die sleutel komt uit data-bottom-sheet-key, dat de snippet met dezelfde
 * Liquid-filter (| handleize) vult als voorheen. snippets/av-akkoord-check.liquid
 * roept window['bottomSheet_av-akkoord-sheet'].open() aan vanuit een onclick;
 * dat blijft werken, want een klik gebeurt ruim na het defer-moment.
 * Daarnaast blijven de events bottom-sheet:open en bottom-sheet:close werken.
 *
 * Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  'use strict';

  var GEBONDEN = 'bottomSheetGebonden';

  function bind(sheet) {
    if (sheet.dataset[GEBONDEN] === 'ja') return;
    sheet.dataset[GEBONDEN] = 'ja';

    var overlay = sheet.querySelector('[data-bottom-sheet-overlay]');
    var panel = sheet.querySelector('[data-bottom-sheet-panel]');
    var closeBtn = sheet.querySelector('[data-bottom-sheet-close]');
    var handle = sheet.querySelector('[data-bottom-sheet-handle]');

    function open() {
      sheet.style.display = 'block';
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        if (overlay) overlay.style.opacity = '1';
        if (panel) panel.style.transform = 'translateY(0)';
      });
    }

    function close() {
      if (panel) panel.style.transform = 'translateY(100%)';
      if (overlay) overlay.style.opacity = '0';
      setTimeout(function () {
        sheet.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Escape key closes */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.style.display !== 'none') close();
    });

    /* Swipe-down to close via drag handle */
    var startY = 0;
    var isDragging = false;

    if (handle) {
      handle.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      handle.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        var diff = e.touches[0].clientY - startY;
        if (diff > 0 && panel) {
          panel.style.transition = 'none';
          panel.style.transform = 'translateY(' + diff + 'px)';
        }
      }, { passive: true });

      handle.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = e.changedTouches[0].clientY - startY;
        if (panel) panel.style.transition = 'transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)';
        if (diff > 80) {
          close();
        } else if (panel) {
          panel.style.transform = 'translateY(0)';
        }
      });
    }

    /* Expose open/close globally, zelfde sleutel als voorheen */
    var sleutel = sheet.getAttribute('data-bottom-sheet-key') || sheet.id;
    window['bottomSheet_' + sleutel] = { open: open, close: close };

    /* Also dispatch custom events */
    sheet.addEventListener('bottom-sheet:open', open);
    sheet.addEventListener('bottom-sheet:close', close);
  }

  function init(scope) {
    var wortel = scope && scope.querySelectorAll ? scope : document;
    var sheets = wortel.querySelectorAll('[data-bottom-sheet]');
    for (var i = 0; i < sheets.length; i++) bind(sheets[i]);
  }

  init(document);

  /* Een via innerHTML ingevoegde <script src> voert niet uit, dus opnieuw
     binden zodra Shopify een section herlaadt. De guard op data-bottomSheetGebonden
     voorkomt dubbele listeners op bestaande sheets. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
